"use strict";

export default function templateCourseBreadcrumbs(label) {
  let html = `<div id="courseBreadcrumbs" class="breadcrumbs"><a href="/courses">Modules</a> / ${label}</div>`;
  return html;
}
